"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class DeleteBlogModal extends _react.Component {
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.delete('/blog/delete', {
      id: props.blog_to_delete
    }).then((xhr, response) => {
      component.setState({
        loading: false,
        info: "Succès de suppression de la ressource"
      });
      props.onClose();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
    props.onClose();
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.onClose) props.onClose();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const delete_button = /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      className: "c-flat-btn",
      color: "primary"
    }, "Supprimer");
    const info = (0, _getFormStatus.default)({
      warning: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, "\xCAtes-vous sur de vouloir supprimer cette ressource ? Cette action est irr\xE9versible.")
    });
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Suppression d'une ressource",
      "scroll-area": ".back-page",
      bemit: ['small', 'simple'],
      "close-label": "Annuler",
      "action-buttons": delete_button,
      src: props.trigger_src,
      "close-classes": "c-flat-btn c-flat-btn--red u-margin-right-10"
    }, info);
    return output;
  }
}
exports.default = DeleteBlogModal;
